module.exports = __webpack_public_path__ + "img/1557614086207905794.2af5a855.png";